import {
  FormControl,
  InputLabel,
  Select,
  SelectChangeEvent,
  SxProps,
  Theme,
} from '@mui/material';
import React from 'react';

export interface SortByDropdownProps {
  /** Current sort value */
  value: string;
  /** Change handler for when user selects a different option */
  onChange: (event: SelectChangeEvent<string>) => void;
  /** MenuItem components to display as options */
  children: React.ReactNode;
  /** Label text for the dropdown (defaults to "Sort by") */
  label?: string;
  /** Aria label for accessibility */
  ariaLabel?: string;
  /** Additional styling for the FormControl */
  sx?: SxProps<Theme>;
  /** Size variant */
  size?: 'small' | 'medium';
  /** Minimum width (defaults to 150) */
  minWidth?: number;
}

export const SortByDropdown = ({
  value,
  onChange,
  children,
  label = 'Sort by',
  ariaLabel,
  sx,
  size = 'small',
  minWidth = 150,
}: SortByDropdownProps) => {
  return (
    <FormControl size={size} sx={{ minWidth, ...sx }}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={onChange}
        inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
      >
        {children}
      </Select>
    </FormControl>
  );
};
